export type CustomFields = { [key: string]: string | undefined };
export const FILTER_OPTION_PARAM_KEY = 'filter';
export const SORTING_OPTION_PARAM_KEY = 'sorting';
export const CUSTOM_FIELD_PARAM_KEY = 'cField';
